// OEM App 定制 — 项目 mock 数据与状态初始化
// TODO: 联调时替换为接口数据
import { buildChecklist } from './materialConfig';

// 项目阶段：phase1(开发一阶段) → phase2(开发二阶段)
// targets：平台 + 上架区域的关联配置，如 [{ platform:'android', regions:['cn','os'] }, { platform:'ios', regions:'cn' }]
// p1/p2：第一/第二阶段资料完成度（列表展示用，{ done, total }）
// doneInStage：详情页初始化当前阶段已保存项数
export const MOCK_PROJECTS = [
    {
        id: 'OEM-1001', appName: '智联安防', companyName: 'test-东莞康林物联网有限公司', companyId: 'test-JGSf0Nd7',
        targets: [{ platform: 'android', regions: ['cn'] }], stage: 'phase1',
        p1: { done: 4, total: 12 }, p2: { done: 0, total: 14 }, createdAt: '2026-09-01 10:20', doneInStage: 4,
    },
    {
        id: 'OEM-1002', appName: '云眸智能', companyName: 'test-深圳智联科技有限公司', companyId: 'test-SZ888',
        targets: [{ platform: 'ios', regions: 'cn' }], stage: 'phase1',
        p1: { done: 12, total: 12 }, p2: { done: 0, total: 8 }, createdAt: '2026-08-25 14:00', doneInStage: 30,
    },
    {
        id: 'OEM-1003', appName: 'GlobalEye', companyName: 'test-深圳云端科技有限公司', companyId: 'test-SZ666',
        targets: [{ platform: 'android', regions: ['os'] }, { platform: 'ios', regions: 'os' }], stage: 'phase2',
        p1: { done: 12, total: 12 }, p2: { done: 20, total: 28 }, createdAt: '2026-08-18 09:10', doneInStage: 4,
    },
    {
        id: 'OEM-1004', appName: '慧眼物联', companyName: 'test-杭州数智网络有限公司', companyId: 'test-HZ999',
        targets: [{ platform: 'android', regions: ['cn', 'os'] }], stage: 'phase1',
        p1: { done: 2, total: 18 }, p2: { done: 0, total: 20 }, createdAt: '2026-09-05 16:40', doneInStage: 3,
    },
    {
        id: 'OEM-1005', appName: 'HmCamera', companyName: 'test-北京云联科技有限公司', companyId: 'test-BJ666',
        targets: [{ platform: 'ios', regions: 'global' }], stage: 'phase2',
        p1: { done: 12, total: 12 }, p2: { done: 16, total: 16 }, createdAt: '2026-07-30 11:00', doneInStage: 20,
    },
    {
        id: 'OEM-1006', appName: '视界云', companyName: 'test-成都智眼科技有限公司', companyId: 'test-CD555',
        targets: [{ platform: 'android', regions: ['cn', 'os'] }, { platform: 'ios', regions: 'os' }], stage: 'phase1',
        p1: { done: 6, total: 20 }, p2: { done: 0, total: 18 }, createdAt: '2026-09-08 08:30', doneInStage: 2,
    },
    {
        id: 'OEM-1007', appName: '全场景智能', companyName: 'test-广州全场景科技有限公司', companyId: 'test-GZ001',
        targets: [{ platform: 'android', regions: ['cn', 'os'] }, { platform: 'ios', regions: 'global' }], stage: 'phase1',
        p1: { done: 20, total: 20 }, p2: { done: 76, total: 76 }, createdAt: '2026-09-10 09:00', doneInStage: 96,
    },
    {
        id: 'OEM-1008', appName: '云视通', companyName: 'test-上海云视科技有限公司', companyId: 'test-SH008',
        targets: [{ platform: 'android', regions: ['cn', 'os'] }, { platform: 'ios', regions: 'global' }], stage: 'phase1',
        p1: { done: 20, total: 20 }, p2: { done: 76, total: 76 }, createdAt: '2026-09-11 15:30', doneInStage: 96,
    },
    // 一阶段已构建、尚未创建应用（用于演示列表「创建应用」入口）
    {
        id: 'OEM-1009', appName: '智联门禁', companyName: 'test-苏州智联门禁科技有限公司', companyId: 'test-SZ009',
        targets: [{ platform: 'android', regions: ['cn'] }, { platform: 'ios', regions: ['cn'] }], stage: 'phase1',
        p1: { done: 12, total: 12 }, p2: { done: 0, total: 8 }, createdAt: '2026-09-12 10:30', doneInStage: 12,
    },
    // 定制申请待审核（未开放资料填写）
    {
        id: 'OEM-1010', appName: '安视云', companyName: 'test-南京安视云科技有限公司', companyId: 'test-NJ010',
        targets: [{ platform: 'android', regions: ['cn', 'os'] }], stage: 'phase1',
        p1: { done: 0, total: 18 }, p2: { done: 0, total: 20 }, createdAt: '2026-09-13 09:20', doneInStage: 0,
    },
    // 定制申请已驳回（待企业修改后重新提交）
    {
        id: 'OEM-1011', appName: '智慧园区', companyName: 'test-武汉智慧园区科技有限公司', companyId: 'test-WH011',
        targets: [{ platform: 'ios', regions: 'global' }], stage: 'phase1',
        p1: { done: 0, total: 12 }, p2: { done: 0, total: 16 }, createdAt: '2026-09-12 15:40', doneInStage: 0,
    },
];

export const findProject = (id) => MOCK_PROJECTS.find((p) => p.id === id) || null;

// 初始化各资料项状态：仅「待填写 / 已保存」，无审核流程
// 直接依据 p1 / p2 完成度：前 pX.done 项 = 已保存，其余待填写
const mockValue = (it) => {
    if (it.mode === 'color') return '#1677ff';
    if (it.kind === 'image') return `${it.name}.png`;
    if (it.mode === 'file') return `${it.name}.pdf`;
    return `示例内容：${it.name}`;
};

// 渠道项的示例配置（全部渠道视为已配置）
const mockChannelsConfig = (it) => {
    const selected = (it.channels || []).map((c) => c.key);
    const data = {};
    (it.channels || []).forEach((c) => {
        const f = {};
        (c.fields || []).forEach((x) => { const name = typeof x === 'string' ? x : x.name; f[name] = '示例值'; });
        data[c.key] = f;
    });
    return { selected, data };
};

export const buildItemStateMap = (project) => {
    const stages = buildChecklist(project.targets);
    const savedByStage = { phase1: project.p1?.done || 0, phase2: project.p2?.done || 0 };
    const map = {};
    stages.forEach((stage) => {
        const flat = stage.sections.flatMap((sec) => sec.items);
        const saved = savedByStage[stage.key] || 0;
        flat.forEach((it, i) => {
            if (i < saved) {
                map[it.key] = it.mode === 'channels'
                    ? { status: 'draft', value: '已配置', config: mockChannelsConfig(it) }
                    : { status: 'draft', value: mockValue(it) };
            } else {
                map[it.key] = { status: 'pending', value: '' };
            }
        });
    });
    return map;
};
